import { Routes, Route } from "react-router-dom";
import MainLayout from "../layout/MainLayout";

// Pages Imports
import Home from "../pages/Home";
import About from "../pages/About";
import Services from "../pages/Services";
import KnowledgeBank from "../pages/KnowledgeBank";
import Contact from "../pages/Contact";
import GstVat from "../pages/gstvat";
import ImportantLinks from "../pages/importantlinks";
export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/knowledge-bank" element={<KnowledgeBank />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gst-vat-links" element={<GstVat />} />
        <Route path="/important-links" element={<ImportantLinks />} />
      </Route>
    </Routes>
  );
}